import httpInstance from "@/utils/http";

// 账号密码登录接口
export const UserLoginAPI = ({email, password}) => {
  return httpInstance({
    url: '/user/login',
    method: 'POST',
    data: {
      email,
      password
    }
  })
}

// 手机号登录获取验证码接口
export const GetVerificationCodeAPI = (params) => {
  return httpInstance({
    url: `/user/phoneLoginGetCode?phoneNumber=${params}`,
    method: 'GET',
  })
}

// 手机号登录接口
export const PhoneLoginAPI = (data) => {
  return httpInstance({
    url: '/user/phoneLogin',
    method: 'POST',
    data
  })
}
